exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-264f7684]{width:320px}.flex[data-v-264f7684]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.flex-btn[data-v-264f7684]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[data-v-264f7684] .el-drawer__body{overflow:scroll;padding-bottom:80px}", ""]);

// exports
